import text from 'component/text';

function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null;
}
var currentSource = parseInt(getQueryString('source'));

var config = {};

function getConfig(json){
	  var list = json.list;
	  if (list) {
	    list.forEach(item => {
	      if (item.order) {
	        if (item.sourceMap[0] <= currentSource && currentSource <= item.sourceMap[1]){
	          Object.assign(config,item.config);
          }
        } else {
          item.sourceMap.forEach(source => {
            if (currentSource === source){
              Object.assign(config, item.config);
            }
          });
        }
	    });
	  }
	  return config;

}

export default getConfig;



// WEBPACK FOOTER //
// ./src/component/common/regConfig.js